<template>
  <div class="video-upload-info-container">
    <el-upload
      :action="`${env.VUE_APP_fileserver}persistentUpload`"
      :show-file-list="false"
      :before-upload="beforeUploadCheck"
      :on-progress="uploadProgress"
      :on-success="uploadSuccess"
    >
      <div v-if="videoUrl" class="video-box">
        <video class="video-player" :src="videoUrl" controls @click.stop="">您的浏览器不支持视频播放</video>
        <i class="el-icon-circle-close delete-video-icon" @click.stop="deleteVideoClick"></i>
      </div>

      <template v-else>
        <div v-if="!isShowProgress" class="plus-box">
          <i class="el-icon-plus plus-icon"></i>
        </div>
        <el-progress v-else type="circle" :percentage="percent"></el-progress>
      </template>
    </el-upload>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      env: process.env,
      videoUrl: "",
      isShowProgress: false,
      percent: 0,
    };
  },
  methods: {
    deleteVideoClick() {
      this.videoUrl = "";
    },
    //上传前回调
    beforeUploadCheck(file) {
      var fileSize = file.size / 1024 / 1024 < 50;
      const typeArr = ["video/mp4", "video/ogv", "video/webm"];
      if (!typeArr.includes(file.type)) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!fileSize) {
        this.$message.error("视频大小不能超过50MB");
        return false;
      }

      return true;
    },
    uploadProgress(event) {
      this.isShowProgress = true;
      this.percent = parseInt(event.percent);
    },
    //上传
    uploadSuccess(res) {
      const {
        data: { url },
      } = res;

      this.videoUrl = url;
      this.isShowProgress = false;
      this.percent = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-upload-info-container {
  .video-box {
    width: 148px;
    height: 148px;
    position: relative;
    .video-player {
      width: 100%;
      height: 100%;
    }
    .delete-video-icon {
      position: absolute;
      top: -5px;
      right: -14px;
    }
  }
  .plus-box {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color: #fbfdff;
    &:hover {
      border-color: #1890ff;
    }
    .plus-icon {
      font-size: 28px;
      color: #8c939d;
      width: 148px;
      height: 148px;
      line-height: 148px;
      text-align: center;
    }
  }
}
</style>
